import React from 'react';
import { Container, Loading } from './styles';

import typ from './index.d' 
const Button :React.FC<typ.Props> = ({title, callback, customStyle, iconRight: IconRight, isLoading}) => {
   return (
      <Container onClick={callback} style={customStyle} disabled={isLoading}>
         {IconRight && <IconRight />}
         {title}
         {isLoading && <Loading />}
      </Container>
   );
}

export default Button ;